import React, { useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import doctoresIcon from "../img/doctores-icon.png";
import pacientesIcon from "../img/pacientes-icon.png";
import empleadosIcon from "../img/empleados-icon.png";
import sucursalesIcon from "../img/sucursales-icon.png";
import conveniosIcon from "../img/convenios-icon.png";
import informesIcon from "../img/informes-icon.png";
import estudiosIcon from "../img/estudios-icon.png";
import solicitudesIcon from "../img/solicitudes-icon.png";
import reportesIcon from "../img/reportes-icon.png";
import entregasIcon from "../img/entregas-icon.png";
import cotizacionesIcon from "../img/cotizaciones-icon.png";
import egresosIcon from "../img/egresos-icon.png";
import corteCajaIcon from "../img/cortecaja-icon.png";
import cuentasCobrarIcon from "../img/cuentas-icon.png";
import listasPreciosIcon from "../img/listasPrecios-icon.png";
import cargaMasivaIcon from "../img/cargaMasiva-icon.png";
import recepcionMuestrasIcon from "../img/recepcionMuestras-icon.png";
import inventarioIcon from "../img/inventario-icon.png";

const Menu = () => {

  useEffect(() => {
    document.title = "Menú";
  }, []);
  const navigate = useNavigate();
  const modules = [
    {
      label: "DOCTORES",
      icon: (
        <img
          src={doctoresIcon}
          alt="Doctores"
          style={{ width: "100%", height: "100%" }}
        />
      ),
      path: "/doctores",
    },
    {
      label: "PACIENTES",
      icon: (
        <img
          src={pacientesIcon}
          alt="Pacientes"
          style={{ width: "80%", height: "80%" }}
        />
      ),
      path: "/pacientes",
    },
    {
      label: "EMPLEADOS",
      icon: (
        <img
          src={empleadosIcon}
          alt="Empleados"
          style={{ width: "80%", height: "80%" }}
        />
      ),
      path: "/empleados",
    },
    {
      label: "SUCURSALES",
      icon: (
        <img
          src={sucursalesIcon}
          alt="Sucursales"
          style={{ width: "100%", height: "100%" }}
        />
      ),
      path: "/sucursales",
    },
    {
      label: "CONVENIOS", icon: (
        <img
          src={conveniosIcon}
          alt="Convenios"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/convenios"
    },
    {
      label: "INFORMES", icon: (
        <img
          src={informesIcon}
          alt="Informes"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/informes"
    },
    {
      label: "ESTUDIOS", icon: (
        <img
          src={estudiosIcon}
          alt="Estudios"
          style={{ width: "65%", height: "65%" }}
        />
      ), path: "/estudios"
    },
    {
      label: "SOLICITUD EXAMENES", icon: (
        <img
          src={solicitudesIcon}
          alt="Solicitudes"
          style={{ width: "65%", height: "65%" }}
        />
      ), path: "/solicitudes"
    },
    {
      label: "REPORTES RESULTADOS", icon: (
        <img
          src={reportesIcon}
          alt="Reportes"
          style={{ width: "85%", height: "85%" }}
        />
      ), path: "/reporteResultados"
    },
    {
      label: "ENTREGAS", icon: (
        <img
          src={entregasIcon}
          alt="Entregas"
          style={{ width: "100%", height: "100%" }}
        />
      ), path: "/entregas"
    },
    {
      label: "COTIZACIONES", icon: (
        <img
          src={cotizacionesIcon}
          alt="Cotizaciones"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/cotizaciones"
    },
    {
      label: "EGRESOS E INGRESOS", icon: (
        <img
          src={egresosIcon}
          alt="Egresos"
          style={{ width: "100%", height: "100%" }}
        />
      ), path: "/egresosIngresos"
    },
    {
      label: "CORTE DE CAJA", icon: (
        <img
          src={corteCajaIcon}
          alt="CorteCaja"
          style={{ width: "90%", height: "90%" }}
        />
      ), path: "/corteCaja"
    },
    {
      label: "CUENTAS POR COBRAR", icon: (
        <img
          src={cuentasCobrarIcon}
          alt="CuentasCobrar"
          style={{ width: "100%", height: "100%" }}
        />
      ), path: "/cuentasCobrar"
    },
    {
      label: "LISTAS PRECIOS", icon: (
        <img
          src={listasPreciosIcon}
          alt="ListasPrecios"
          style={{ width: "80%", height: "80%" }}
        />
      ), path: "/listasPrecios"
    },
    {
      label: "CARGA MASIVA SOLICITUDES", icon: (
        <img
          src={cargaMasivaIcon}
          alt="CargaMasiva"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/cargaMasiva"
    },
    {
      label: "RECEPCION MUESTRAS", icon: (
        <img
          src={recepcionMuestrasIcon}
          alt="RecepcionMuestras"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/recepcionMuestras"
    },
    {
      label: "INVENTARIO", icon: (
        <img
          src={inventarioIcon}
          alt="Inventario"
          style={{ width: "70%", height: "70%" }}
        />
      ), path: "/inventario"
    },
  ];

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.5vw",
          }}
        >
          {[0, 7, 14].map((start) => (
            <Grid container spacing={"3vw"} justifyContent="center" key={start}>
              {modules.slice(start, start + 7).map((mod, index) => (
                <Grid item xs={2} key={index}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Tooltip
                      title={mod.label}
                      arrow
                      placement="top"
                      slotProps={{
                        popper: {
                          sx: {
                            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                            {
                              marginTop: "0px",
                            },
                            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                            {
                              marginBottom: "0.2vw",
                            },
                            [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                            {
                              marginLeft: "0px",
                            },
                            [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                            {
                              marginRight: "0px",
                            },
                            zIndex: 3000,
                          },
                        },
                        tooltip: {
                          sx: {
                            fontSize: "0.7vw",
                            padding: "0.5vw 0.5vw",
                            borderRadius: "8px",
                            backgroundColor: "rgba(255,255,255,0.9)",
                            fontWeight: "bold",
                            fontFamily: "Roboto-Medium",
                            color: "#000000",
                            marginBottom: "-5px",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "rgba(255,255,255,0.9)",
                          },
                        },
                      }}
                    >
                      <Paper
                        sx={{
                          width: "9.8vw",
                          height: "8.8vw",
                          borderRadius: "12px",
                          border: "2px solid #ccc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            backgroundColor: "rgba(236,232,232,0.84)",
                          },
                        }}
                        onClick={() => navigate(mod.path, { state: { fromApp: true } })}
                      >
                        {mod.icon}
                      </Paper>
                    </Tooltip>
                    <Typography
                      variant="body2"
                      fontWeight="900"
                      sx={{
                        marginTop: "0.1vw",
                        width: "9.8vw",
                        fontSize: "0.7vw",
                        fontWeight: "bold",
                        fontFamily: "Roboto-Medium",
                        backgroundColor: "rgba(255,255,255,0.8)",
                        borderRadius: "8px",
                        padding: "0.1vw 0.1vw",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {mod.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ))}
        </Box>
      </Content>
    </Layout>
  );
};
export default Menu;
